// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.auth-screen {
  position: relative;
  min-height: 100vh;
  display: flex;
  flex-direction: column;
  color: #fff;
  background: #111;
  isolation: isolate;
}

.auth-bg {
  position: fixed;
  inset: 0;
  z-index: -1;
  background-size: cover;
  background-position: center;
  filter: brightness(0.3);
}

.auth-header {
  min-height: 70px;
  padding: 0 30px;
  display: flex;
  align-items: center;
  border-bottom: 1px solid rgba(255, 255, 255, 0.15);
}

.auth-logo {
  display: flex;
  align-items: center;
  gap: 14px;
}
.auth-logo img {
  height: 44px;
  transform: skewX(-8deg);
}
.auth-logo .company-name {
  display: flex;
  flex-direction: column;
  line-height: 1.1;
  font-weight: 800;
  font-size: 15px;
  color: #fff;
}

.auth-body {
  flex: 1 1;
  display: flex;
  justify-content: center;
  align-items: flex-start;
  padding: 72px 16px 40px;
}

.auth-form-box {
  width: 100%;
  max-width: 400px;
}
.auth-form-box .auth-heading {
  font-size: 32px;
  font-weight: 500;
  color: #fff;
  margin-bottom: 6px;
}
.auth-form-box .auth-subheading {
  color: rgba(255, 255, 255, 0.7);
  margin-bottom: 28px;
}
.auth-form-box .form-label,
.auth-form-box label {
  color: #fff;
}
.auth-form-box .form-control,
.auth-form-box .form-select {
  background: #fff;
  color: #212529;
}
.auth-form-box .text-muted {
  color: rgba(255, 255, 255, 0.7) !important;
}
.auth-form-box a {
  color: #fff;
  text-decoration: underline;
  text-underline-offset: 2px;
}
.auth-form-box .btn-outline-secondary {
  background: #fff;
  color: #333 !important;
}
.auth-form-box .btn-accent-solid {
  padding: 11px 18px;
  font-size: 16px;
}
.auth-form-box .btn-outline {
  background: transparent;
  color: #fff;
  border-color: rgba(255, 255, 255, 0.5);
}
.auth-form-box .btn-outline:hover:not(:disabled) {
  background: rgba(255, 255, 255, 0.1);
  color: #fff;
}
.auth-form-box .btn-link {
  color: var(--color-accent);
  font-weight: 600;
}
.auth-form-box .text-danger {
  color: #ff8a80 !important;
}
.auth-form-box .card {
  background: rgba(255, 255, 255, 0.06);
  border-color: rgba(255, 255, 255, 0.15);
  color: #fff;
}

.auth-footer {
  padding: 18px 30px;
  font-size: 11.5px;
  color: rgba(255, 255, 255, 0.55);
}

@media (max-width: 600px) {
  .auth-header {
    padding: 0 16px;
  }
  .auth-body {
    padding-top: 40px;
  }
}`, "",{"version":3,"sources":["webpack://./src/components/Auth/Auth.scss"],"names":[],"mappings":"AAAA;EACC,kBAAA;EACA,iBAAA;EACA,aAAA;EACA,sBAAA;EACA,WAAA;EACA,gBAAA;EACA,kBAAA;AACD;;AAEA;EACC,eAAA;EACA,QAAA;EACA,WAAA;EACA,sBAAA;EACA,2BAAA;EACA,uBAAA;AACD;;AAEA;EACC,gBAAA;EACA,eAAA;EACA,aAAA;EACA,mBAAA;EACA,kDAAA;AACD;;AAEA;EACC,aAAA;EACA,mBAAA;EACA,SAAA;AACD;AACC;EACC,YAAA;EACA,uBAAA;AACF;AAEC;EACC,aAAA;EACA,sBAAA;EACA,gBAAA;EACA,gBAAA;EACA,eAAA;EACA,WAAA;AAAF;;AAIA;EACC,SAAA;EACA,aAAA;EACA,uBAAA;EACA,uBAAA;EACA,uBAAA;AADD;;AAIA;EACC,WAAA;EACA,gBAAA;AADD;AAGC;EACC,eAAA;EACA,gBAAA;EACA,WAAA;EACA,kBAAA;AADF;AAIC;EACC,+BAAA;EACA,mBAAA;AAFF;AAKC;;EAEC,WAAA;AAHF;AAMC;;EAEC,gBAAA;EACA,cAAA;AAJF;AAOC;EACC,0CAAA;AALF;AAQC;EACC,WAAA;EACA,0BAAA;EACA,0BAAA;AANF;AASC;EACC,gBAAA;EACA,sBAAA;AAPF;AAUC;EACC,kBAAA;EACA,eAAA;AARF;AAWC;EACC,uBAAA;EACA,WAAA;EACA,sCAAA;AATF;AAWE;EACC,oCAAA;EACA,WAAA;AATH;AAaC;EACC,0BAAA;EACA,gBAAA;AAXF;AAcC;EACC,yBAAA;AAZF;AAeC;EACC,qCAAA;EACA,uCAAA;EACA,WAAA;AAbF;;AAiBA;EACC,kBAAA;EACA,iBAAA;EACA,gCAAA;AAdD;;AAiBA;EACC;IACC,eAAA;EAdA;EAgBD;IACC,iBAAA;EAdA;AACF","sourcesContent":[".auth-screen {\n\tposition: relative;\n\tmin-height: 100vh;\n\tdisplay: flex;\n\tflex-direction: column;\n\tcolor: #fff;\n\tbackground: #111;\n\tisolation: isolate;\n}\n\n.auth-bg {\n\tposition: fixed;\n\tinset: 0;\n\tz-index: -1;\n\tbackground-size: cover;\n\tbackground-position: center;\n\tfilter: brightness(0.3);\n}\n\n.auth-header {\n\tmin-height: 70px;\n\tpadding: 0 30px;\n\tdisplay: flex;\n\talign-items: center;\n\tborder-bottom: 1px solid rgba(255, 255, 255, 0.15);\n}\n\n.auth-logo {\n\tdisplay: flex;\n\talign-items: center;\n\tgap: 14px;\n\n\timg {\n\t\theight: 44px;\n\t\ttransform: skewX(-8deg);\n\t}\n\n\t.company-name {\n\t\tdisplay: flex;\n\t\tflex-direction: column;\n\t\tline-height: 1.1;\n\t\tfont-weight: 800;\n\t\tfont-size: 15px;\n\t\tcolor: #fff;\n\t}\n}\n\n.auth-body {\n\tflex: 1;\n\tdisplay: flex;\n\tjustify-content: center;\n\talign-items: flex-start;\n\tpadding: 72px 16px 40px;\n}\n\n.auth-form-box {\n\twidth: 100%;\n\tmax-width: 400px;\n\n\t.auth-heading {\n\t\tfont-size: 32px;\n\t\tfont-weight: 500;\n\t\tcolor: #fff;\n\t\tmargin-bottom: 6px;\n\t}\n\n\t.auth-subheading {\n\t\tcolor: rgba(255, 255, 255, 0.7);\n\t\tmargin-bottom: 28px;\n\t}\n\n\t.form-label,\n\tlabel {\n\t\tcolor: #fff;\n\t}\n\n\t.form-control,\n\t.form-select {\n\t\tbackground: #fff;\n\t\tcolor: #212529;\n\t}\n\n\t.text-muted {\n\t\tcolor: rgba(255, 255, 255, 0.7) !important;\n\t}\n\n\ta {\n\t\tcolor: #fff;\n\t\ttext-decoration: underline;\n\t\ttext-underline-offset: 2px;\n\t}\n\n\t.btn-outline-secondary {\n\t\tbackground: #fff;\n\t\tcolor: #333 !important;\n\t}\n\n\t.btn-accent-solid {\n\t\tpadding: 11px 18px;\n\t\tfont-size: 16px;\n\t}\n\n\t.btn-outline {\n\t\tbackground: transparent;\n\t\tcolor: #fff;\n\t\tborder-color: rgba(255, 255, 255, 0.5);\n\n\t\t&:hover:not(:disabled) {\n\t\t\tbackground: rgba(255, 255, 255, 0.1);\n\t\t\tcolor: #fff;\n\t\t}\n\t}\n\n\t.btn-link {\n\t\tcolor: var(--color-accent);\n\t\tfont-weight: 600;\n\t}\n\n\t.text-danger {\n\t\tcolor: #ff8a80 !important;\n\t}\n\n\t.card {\n\t\tbackground: rgba(255, 255, 255, 0.06);\n\t\tborder-color: rgba(255, 255, 255, 0.15);\n\t\tcolor: #fff;\n\t}\n}\n\n.auth-footer {\n\tpadding: 18px 30px;\n\tfont-size: 11.5px;\n\tcolor: rgba(255, 255, 255, 0.55);\n}\n\n@media (max-width: 600px) {\n\t.auth-header {\n\t\tpadding: 0 16px;\n\t}\n\t.auth-body {\n\t\tpadding-top: 40px;\n\t}\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
